import StorageError from './StorageError';

export default StorageError;
